import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';

const initialState = {
    dispatchsuggestion: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getDispatchSuggestion = createAsyncThunk(
    'dispatchsuggestion/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDispatchSuggestion', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.dispatchSuggestion;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addDispatchSuggestion = createAsyncThunk(
    'dispatchsuggestion/add',
    async ({ data }, { dispatch, rejectWithValue }) => {
        console.log("data", data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createDispatchSuggestion', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data);
            dispatch(getDispatchSuggestion());
            return response.data.dispatchSuggestion;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteDispatchSuggestion = createAsyncThunk(
    'dispatchsuggestion/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteDispatchSuggestion/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const viewDispatchSuggestion = createAsyncThunk(
    'dispatchsuggestion/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getDispatchSuggestionById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.dispatchSuggestion;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const editDispatchSuggestion = createAsyncThunk(
    'dispatchsuggestion/edit',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const { _id, navigate, ...rest } = data;
            const response = await axiosInstance.put(`${BASE_URL}/updateDispatchSuggestion/${_id}`, data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getDispatchSuggestion());
            return response.data.dispatchSuggestion;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteDispatchDetails = createAsyncThunk(
    'dispatchsuggestion/deleteDetails',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteDispatchDetails/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));

            return response.data.dispatchSuggestion;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const getSuggestionCategoty = createAsyncThunk(
    'getSuggestionCategoty/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getListCategoryInDispatchSuggestion', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getSuggestionSubCategoty = createAsyncThunk(
    'getSuggestionSubCategoty/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getListSubCategoryInDispatchSuggestion', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getSuggestionProduct = createAsyncThunk(
    'getSuggestionProduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getListProductInDispatchSuggestion', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);




const dispatchSuggestionSlice = createSlice({
    name: 'dispatchsuggestion',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDispatchSuggestion.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchsuggestion...';
            })
            .addCase(getDispatchSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'DispatchSuggestion fetched successfully';
                state.dispatchsuggestion = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getDispatchSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchsuggestion';
            })
            // Add DispatchSuggestion
            .addCase(addDispatchSuggestion.pending, (state) => {
                state.loading = true;
                state.message = 'Adding dispatchsuggestion...';
            })
            .addCase(addDispatchSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchsuggestion.push(action.payload);
                state.message = action.payload?.message || 'DispatchSuggestion added successfully';
            })
            .addCase(addDispatchSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add dispatchsuggestion';
            })
            // Delete DispatchSuggestion
            .addCase(deleteDispatchSuggestion.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting dispatchsuggestion...';
            })
            .addCase(deleteDispatchSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchsuggestion = state.dispatchsuggestion.filter((dispatch) => dispatch._id !== action.payload);
                state.message = action.payload?.message || 'DispatchSuggestion deleted successfully';
            })
            .addCase(deleteDispatchSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete dispatchsuggestion';
            })
            // Delete DispatchDetails
            .addCase(deleteDispatchDetails.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting dispatchdetails...';
            })
            .addCase(deleteDispatchDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchsuggestion = state.dispatchsuggestion.filter((dispatch) => dispatch._id !== action.payload);
                state.message = action.payload?.message || 'DispatchDetails deleted successfully';
            })
            .addCase(deleteDispatchDetails.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete dispatchdetails';
            })
            // Edit DispatchSuggestion
            .addCase(editDispatchSuggestion.pending, (state) => {
                state.loading = true;
                state.message = 'Editing dispatchsuggestion...';
            })
            .addCase(editDispatchSuggestion.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dispatchsuggestion = state.dispatchsuggestion.map((dispatch) =>
                    dispatch._id === action.payload._id ? action.payload : dispatch
                );
                state.message = action.payload?.message || 'DispatchSuggestion updated successfully';
            })
            .addCase(editDispatchSuggestion.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update dispatchsuggestion';
            })
            //  Add Suggestion Category
            .addCase(getSuggestionCategoty.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchsuggestion...';
            })
            .addCase(getSuggestionCategoty.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'DispatchSuggestion fetched successfully';
                state.category = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getSuggestionCategoty.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchsuggestion';
            })
            //  Add Suggestion subCategory
            .addCase(getSuggestionSubCategoty.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchsuggestion...';
            })
            .addCase(getSuggestionSubCategoty.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'DispatchSuggestion fetched successfully';
                state.subCategory = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getSuggestionSubCategoty.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchsuggestion';
            })
            //  Add Suggestion Product
            .addCase(getSuggestionProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching dispatchsuggestion...';
            })
            .addCase(getSuggestionProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'DispatchSuggestion fetched successfully';
                state.products = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getSuggestionProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch dispatchsuggestion';
            })
    },
});

export default dispatchSuggestionSlice.reducer;
